module.exports = __webpack_public_path__ + "img/17.d9388dc5.jpg";